import { AuthService } from '@/api/auth-service';
import { UserApiService } from './user-api-service';
import { CartApiService } from './cart-api-service';
import { MerchantApiService } from './merchant-api-service';
import { OrderApiService } from './order-api-service';

const authService = new AuthService();

export const merchantApiService = new MerchantApiService();
export const userApiService = new UserApiService(authService);
export const cartApiService = new CartApiService(authService);
export const orderApiService = new OrderApiService(authService);
